function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-translate';
import { actions as commentsActions } from '../redux/comments';
import { getSource } from '../utils/knreise';
import { Button, Glyphicon } from 'react-bootstrap';
import { ensureArticleModuleConfig } from '../hocs/ensureArticleModuleConfig';
import './Comments.scss';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, commentsActions), dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    articleId: state.comments.articleId,
    comments: state.comments.comments,
    commentsLoading: state.comments.commentsLoading,
    flagging: state.comments.flagging,
    flagged: state.comments.flagged,
    flaggingError: state.comments.flaggingError,
    activePage: state.comments.page,
    pages: state.comments.pages
  };
};

export var Comments = function (_React$Component) {
  _inherits(Comments, _React$Component);

  function Comments() {
    _classCallCheck(this, Comments);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Comments.prototype.componentDidMount = function componentDidMount() {
    this.checkArticle(this.props);
  };

  Comments.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkArticle(nextProps);
  };

  Comments.prototype.checkArticle = function checkArticle(props) {
    var id = props.id,
        articleId = props.articleId,
        loadComments = props.loadComments,
        activePage = props.activePage;

    if (articleId !== id) {
      loadComments(id, activePage);
    }
  };

  Comments.prototype.handlePaging = function handlePaging(action) {
    var _props = this.props,
        activePage = _props.activePage,
        pages = _props.pages,
        loadComments = _props.loadComments,
        id = _props.id;

    if (action === 'next' && activePage < pages) {
      loadComments(id, activePage + 1);
    } else if (action === 'prev' && activePage > 1) {
      loadComments(id, activePage - 1);
    }
  };

  Comments.prototype.formatDate = function formatDate(date) {
    var locale = this.props.t('locale');
    var opts = {
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    };
    return date.toLocaleString(locale, opts);
  };

  Comments.prototype.openCommentArticle = function openCommentArticle(comment) {
    var openArticle = this.props.openArticle;
    var source = comment.datasource_data_index && getSource(comment.datasource_data_index);

    if (source) {
      openArticle(comment.article_id, [source.dataIndex].concat(comment.article_id.split('_').slice(1)).join('_'), source);
    } else {
      openArticle(comment.article_id);
    }
  };

  Comments.prototype.renderComment = function renderComment(comment) {
    var _this2 = this;

    var _props2 = this.props,
        flagging = _props2.flagging,
        flagged = _props2.flagged,
        flagComment = _props2.flagComment,
        t = _props2.t,
        linkToArticle = _props2.linkToArticle;
    var source = comment.datasource_data_index && getSource(comment.datasource_data_index);
    return React.createElement('div', {
      className: 'comments--comment',
      key: comment.uuid
    }, React.createElement('span', {
      className: 'comments--flagWrap'
    }, flagging.indexOf(comment.uuid) !== -1 || flagged.indexOf(comment.uuid) !== -1 ? React.createElement('p', {
      className: 'comments--flagged'
    }, t('Flagged')) : !comment.white_listed && React.createElement(Glyphicon, {
      className: 'comments--flag',
      glyph: 'flag',
      title: t('Flag'),
      onClick: function onClick() {
        return flagComment(comment.uuid);
      }
    })), React.createElement('h3', {
      className: 'comments--author',
      title: comment.displayName
    }, comment.displayName), React.createElement('span', {
      className: 'comments--date'
    }, this.formatDate(comment.create_date)), React.createElement('div', {
      className: 'clearfix'
    }), React.createElement('p', {
      className: 'comments--styles'
    }, comment.comment), linkToArticle && React.createElement('a', {
      href: 'javascript:;',
      onClick: function onClick() {
        return _this2.openCommentArticle(comment);
      }
    }, (source ? source.text + ' / ' : '') + (comment.title || t('NoTitle'))));
  };

  Comments.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        comments = _props3.comments,
        commentsLoading = _props3.commentsLoading,
        activePage = _props3.activePage,
        pages = _props3.pages,
        t = _props3.t;
    return React.createElement('div', {
      className: ['comments--window', commentsLoading ? 'comments--loading' : ''].join(' ')
    }, comments && comments.map(function (comment) {
      return _this3.renderComment(comment);
    }), React.createElement('div', {
      className: 'comments--pagingToolbar'
    }, React.createElement(Button, {
      disabled: activePage === 1,
      bsStyle: 'link',
      onClick: function onClick() {
        return _this3.handlePaging('prev');
      }
    }, "\u2190 ", t('Previous')), React.createElement('span', {
      className: 'comments--pageText'
    }, t('Page') + ' ' + activePage + ' ' + t('Of') + ' ' + (pages || 1)), React.createElement(Button, {
      disabled: !pages || activePage === pages,
      bsStyle: 'link',
      onClick: function onClick() {
        return _this3.handlePaging('next');
      }
    }, t('Next'), " \u2192")));
  };

  return Comments;
}(React.Component);
Comments.propTypes = process.env.NODE_ENV !== "production" ? {
  t: PropTypes.func.isRequired,
  id: PropTypes.string,
  articleId: PropTypes.string,
  readBaseUrl: PropTypes.string,
  flagging: PropTypes.array,
  flagged: PropTypes.array,
  flaggingError: PropTypes.bool,
  flagComment: PropTypes.func.isRequired,
  comments: PropTypes.array,
  loadComments: PropTypes.func.isRequired,
  commentsLoading: PropTypes.bool,
  activePage: PropTypes.number,
  pages: PropTypes.number,
  linkToArticle: PropTypes.bool,
  openArticle: PropTypes.func.isRequired
} : {};
export default connect(mapStateToProps, mapDispatchToProps)(translate('Comments')(ensureArticleModuleConfig(Comments)));